import { render, staticRenderFns } from "./UserPlanShippedHistoryList.vue?vue&type=template&id=797d71f1"
import script from "./UserPlanShippedHistoryList.vue?vue&type=script&lang=js"
export * from "./UserPlanShippedHistoryList.vue?vue&type=script&lang=js"
import style0 from "./UserPlanShippedHistoryList.vue?vue&type=style&index=0&id=797d71f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports